import { axiosInstance } from '../../../api/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import APIEndpoints from '../../../Admin/api/APIEndpoints';

const dataKeys = {
  Dependent: {
    FirstName: 'DepFirstName',
    LastName: 'DepLastName',
    MiddleName: 'DepMiddleName',
    CertificateNumber: 'DepCertificateNumber',
    Gender: 'DepGender',
    SocialSecurityNumber: 'DepSocialSecurityNumber',
    Age: 'DepAge',
    OID: 'DependentOid',
    AlternateID1: 'AlternativeID1',
    AlternateID2: 'AlternativeID2',
    ResidentialAddress: 'Dependentresidentailaddress',
    MailingAddress: 'Dependentmailingaddress',
  },
  Member: {
    FirstName: 'FirstName',
    LastName: 'LastName',
    MiddleName: 'MiddleName',
    CertificateNumber: 'CertificateNumber',
    Gender: 'Gender',
    SocialSecurityNumber: 'SocialsecurityNumber',
    Age: 'Age',
    AlternateID1: 'AlternativeID1',
    AlternateID2: 'AlternativeID2',
    ResidentialAddress: 'Memberresidentailaddress',
    MailingAddress: 'Membermailingaddress',
  },
  Employee: {
    FirstName: 'FirstName',
    LastName: 'LastName',
    MiddleName: 'MiddleName',
    CertificateNumber: 'CertificateNumber',
    Gender: 'Gender',
    SocialSecurityNumber: 'SocialsecurityNumber',
    Age: 'Age',
    AlternateID1: 'AlternativeID1',
    AlternateID2: 'AlternativeID2',
    ResidentialAddress: 'Memberresidentailaddress',
    MailingAddress: 'Membermailingaddress',
  },
};

/**@method: getUserData - get userData for member
 * @param: emailId - emailId of member for which user data needs to be fetched
 */
export const getMemberUserData = createAsyncThunk(
  'getMemberUserData',
  async (params, { getState }) => {
    if (params.email) {
      const response = await getMemberUserAndMemberDetails(params.email);
      return { data: response, email: params.email };
    } else {
      return { message: 'email_not_found' };
    }
  },
);

export const getMemberUserAndMemberDetails = async (
  email,
  isAffiliation = false,
) => {
  try {
    const response = await axiosInstance.get(
      `${APIEndpoints.getUserListDetailsResources()}${email}`,
    );
    const userData = response.data.Response.User;
    console.log('new method getuserforallusertypes response is >>>>', userData);
    //const userOid = userData.Oid;
    const userType =
      userData?.MemberDetails?.MemberType === 'Employee'
        ? 'Employee'
        : userData?.MemberDetails?.MemberType;
    const memberOid = userData.MemberDetails.MemberOID;

    //const memberResponse = await axiosInstance.get(
    //`${APIEndpoints.getViewMemberinformation()}oid/${memberOid}/membertype/${userType}`,
    //);
    const memberResponse = await getMemberDetailsByOidAndType(
      memberOid,
      userType,
      isAffiliation === true ? true : false,
    );

    console.log('new method viewmember response is >>>>', {
      userData: userData,
      memberData: memberResponse,
    });

    const memberData = memberResponse.data.Response;
    const memberInfoKey =
      userType === 'Dependent' ? 'DependentsInformation' : 'MemberInformation';
    console.log('&&&&&&&&&& ----- ', memberData);
    const memberDetails = memberData[memberInfoKey];
    const dataKeyByUserType = dataKeys[userType];

    return {
      status: 200,
      statusCode: 'success',
      data: {
        userData: {
          ...userData,
          AltEmailID: memberDetails.AlternativeEmail,
          FirstName: memberDetails[dataKeyByUserType.FirstName]
            ? memberDetails[dataKeyByUserType.FirstName]
            : userData.FirstName,
          LastName: memberDetails[dataKeyByUserType.LastName]
            ? memberDetails[dataKeyByUserType.LastName]
            : userData.LastName,
          CellPhone: memberDetails.MobilePhone,
          MemberDetails: {
            ...userData.MemberDetails,
            ClientName: memberDetails.ClientName,
            Location: memberDetails.Location,
            AlternateID1: memberDetails.AlternativeID1,
            AlternateID2: memberDetails.AlternativeID2,
            CertificateNumber:
              memberDetails[dataKeyByUserType.Certificatenumber],
          },
        },
        //userData: userData,
        memberData: memberData,
      },
    };
  } catch (error) {
    return { statusCode: 'error', error: error };
  }
};

export const getMemberDetailsByOidAndType = async (
  memberOid,
  userType,
  isAffiliation = false,
) => {
  try {
    const memberResponse = await axiosInstance.get(
      isAffiliation
        ? `${APIEndpoints.getViewMemberinformationV2()}oid/${memberOid}/membertype/${userType}`
        : `${APIEndpoints.getViewMemberinformation()}oid/${memberOid}/membertype/${userType}`,
    );
    const userTypeStr = userType[0].toUpperCase() + userType.slice(1);

    const memberInfoKey =
      userTypeStr === 'Dependent'
        ? 'DependentsInformation'
        : 'MemberInformation';
    console.log('&&&&&&&&&& ----- ', memberResponse);
    const memberDetails = memberResponse.data.Response[memberInfoKey];
    const dataKeyByUserType = dataKeys[userTypeStr];

    console.log('fine tuned member details >>>', memberDetails);
    console.log('dataKeyByUserType member details >>>', dataKeyByUserType);

    const modifiedResponse = { ...memberResponse };

    modifiedResponse.data.Response.MemberType = userTypeStr;
    modifiedResponse.data.Response.Member = {
      OID: memberOid,
      FirstName: memberDetails[dataKeyByUserType.FirstName],
      LastName: memberDetails[dataKeyByUserType.LastName],

      ClientName: memberDetails.ClientName,
      LocationName: memberDetails.Location,
      CertificateNumber: memberDetails[dataKeyByUserType.CertificateNumber],
      AlternateID1: memberDetails[dataKeyByUserType.AlternateID1],
      AlternateID2: memberDetails[dataKeyByUserType.AlternateID2],
      BlockOfBusinessName: memberDetails.BlockofBusinessName,
      BirthDate: memberDetails.DateofBirth,
      SocialSecurityNumber:
        memberDetails[dataKeyByUserType.SocialSecurityNumber],
      ContactDetails: {
        PhoneEmail: [
          {
            a: memberDetails.MobilePhone,
            CellPhone1: memberDetails.MobilePhone,
            EmailAddress: memberDetails.Email,
          },
        ],
        Address:
          userType === 'Dependent'
            ? [
                ...memberResponse.data.Response[
                  dataKeyByUserType.ResidentialAddress
                ],
                ...memberResponse.data.Response[
                  dataKeyByUserType.MailingAddress
                ],
              ]
            : [
                {
                  ...memberResponse.data.Response[
                    dataKeyByUserType.ResidentialAddress
                  ],
                },
                {
                  ...memberResponse.data.Response[
                    dataKeyByUserType.MailingAddress
                  ],
                },
              ],
      },
    };
    return modifiedResponse;
  } catch (error) {
    return { statusCode: 'error', status: error?.response?.status };
  }
};

export const getMemberUserDataByEmail = async (email) => {
  try {
    const response = await axiosInstance.get(
      `${APIEndpoints.getUserListDetailsResources()}${email}`,
    );
    const userData = response.data.Response.User;
    console.log('new method getuserforallusertypes response is >>>>', userData);
    return response;
  } catch (error) {
    return { statusCode: 'error', error: error };
  }
};

export const setAdminEmailConfig = createAsyncThunk(
  'setAdminEmailConfig',
  async (params, { getState }) => {
    const response = await axiosInstance.get(
      APIEndpoints.getClientEmailConfiguration(),
    );
    return response?.data?.Response?.Clientconfiguration?.configuration;
  },
);
